/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { CardMetadata, CardSkills, Grid, Typography2 } from '@coursera/cds-core';
import { StarFilledIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/consumer-home';

type Props = {
  skills?: string[];
  averageFiveStarRating?: number;
  ratingCount?: number;
  metadata: string[];
};

const styles = {
  reviewsContainer: css`
    display: flex;
    align-items: center;
    gap: var(--cds-spacing-100);
    padding-top: var(--cds-spacing-150);
  `,
  container: css`
    display: grid;
  `,
};

const RecommendedPathwayBody = ({ skills, averageFiveStarRating, ratingCount, metadata }: Props) => {
  const starRating = averageFiveStarRating?.toFixed(1);

  return (
    <Grid css={styles.container}>
      {skills && skills?.length > 0 && <CardSkills skills={skills} />}
      {!!ratingCount && !!averageFiveStarRating && (
        <Grid item css={styles.reviewsContainer}>
          <StarFilledIcon color="interactive" size="small" />
          <Typography2 aria-label={_t('#{starRating} stars', { starRating })} variant="subtitleMedium" component="h4">
            {starRating}
          </Typography2>
          <Typography2 component="p" variant="bodySecondary" color="supportText">
            {_t('(#{totalReviewCount} reviews)', {
              totalReviewCount: ratingCount.toLocaleString(),
            })}
          </Typography2>
        </Grid>
      )}
      {metadata.length > 0 && <CardMetadata metadata={metadata} />}
    </Grid>
  );
};

export default RecommendedPathwayBody;
